import React from 'react';
import { MenuItem } from 'react-bootstrap';

import NavBarLink from './NavBarLink';
import { can, permActions } from 'permissions';
import { getSubStatus } from 'helpers/subs';
import { withQuickSub } from 'decorators/withSub';

let NavBarQuick = ({ sub, loggedInUser }) => {
  if (!sub) {
    return null;
  }

  const subStatus = getSubStatus(sub);
  const isExpired = subStatus === 'expired';

  const links = [
    {
      to: `/quick/subscriptions/${sub.id}/verification-code`,
      label: 'Send Verification Code',
      permission: can(loggedInUser, permActions.VIEW_QUICK_VERIFICATION_CODE),
    },
    {
      to: `/quick/subscriptions/${sub.id}/carrier-requests`,
      label: 'View Carrier Logs',
    },
    { to: `/quick/subscriptions/${sub.id}/mdn-history`, label: 'MDN History' },
    {
      to: `/quick/subscriptions/${sub.id}/transfer-subscription`,
      label: 'Transfer Subscription',
      condition: !isExpired,
      permission: can(loggedInUser, permActions.TRANSFER_QUICK_SUB),
    },
  ];

  return (
    <React.Fragment>
      <MenuItem divider />
      <MenuItem disabled>
        <b>
          {sub.first_name} {sub.last_name}
          <br />
          Sub ID: {sub.id}
          <br />
          MDN: {sub.mdn}
        </b>
      </MenuItem>
      {links.map((link) => (
        <NavBarLink key={link.to} {...link} />
      ))}
    </React.Fragment>
  );
};

export default withQuickSub(NavBarQuick);
